import img1a from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/1a.webp';
import img1b from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/1b.webp';
import img1c from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/1c.webp';
import img1e from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/1e.webp';
import img1f from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/1f.webp';
import img1g from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/1g.webp';
import img1h from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/1h.webp';
import img1j from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/1j.webp';

import img2a from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/2a.webp';
import img2b from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/2b.webp';
import img2c from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/2c.webp';
import img2d from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/2d.webp';
import img2e from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/2e.webp';
import img2f from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/2f.webp';
import img2g from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/2g.webp';
import img2h from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/2h.webp';
import img2i from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/2i.webp';
import img2j from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/2j.webp';
import img2k from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/2k.webp';
import img2l from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/2l.webp';
import img2n from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/2n.webp';
import img2o from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/2o.webp';
import img2p from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/2p.webp';
import img2r from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/2r.webp';
import img2s from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/2s.webp';
import img2t from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/2t.webp';
import img2u from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/2u.webp';
import img2v from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/2v.webp';
import img2w from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/2w.webp';

import img3a from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/3a.webp';
import img3b from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/3b.webp';
import img3c from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/3c.webp';
import img3d from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/3d.webp';
import img3e from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/3e.webp';
import img3f from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/3f.webp';
import img3g from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/3g.webp';
import img3h from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/3h.webp';
import img3i from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/3i.webp';
import img3j from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/3j.webp';

import img4b from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/4b.webp';
import img4d from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/4d.webp';
import img4e from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/4e.webp';
import img4h from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/4h.webp';
import img4j from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/4j.webp';
import img4l from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/4l.webp';
import img4m from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/4m.webp';

import img5a from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/5a.webp';
import img5c from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/5c.webp';

import img6b from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/6b.webp';
import img6c from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/6c.webp';

import img7a from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/7a.webp';
import img7c from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/7c.webp';
import img7d from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/7d.webp';

import img8b from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/8b.webp';
import img8c from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/8c.webp';
import img8d from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/8d.webp';
import img8e from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/8e.webp';

import img9a from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/9a.webp';
import img9b from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/9b.webp';

import img10c from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/10c.webp';
import img10d from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/10d.webp';
import img10f from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/10f.webp';
import img10g from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/10g.webp';
import img10h from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/10h.webp';
import img10i from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/10i.webp';
import img10j from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/10j.webp';
import img10k from '../../../images/knbf-skjema/seilbat-beregnet-for-overnatting/10k.webp';


const seilbatBeregnetForOvernatting = {
	title: 'Seilbåt beregnet for overnatting',
	logo: 'knbf',
	formDescription: 'Større seilbåt, normalt beregnet for overnatting.',
	tableQuestions: [
		{ header: '1. Er båten tett og fri for vann' },
		{
			text: 'A. På land – skrogets utside – seilbåt',
			legendIcon: 'y',
			modalContent: <p>Kontroller at skroget er fritt for alvorlige skader. På båter med kort kjøl er området rett foran og bak kjølen spesielt utsatt for skader ved grunnstøting.<img src={img1a}/></p>
		},{
			text: 'B. På land – skjøten mellom skrog og kjøl – ballast',
			legendIcon: 'y',
			modalContent: <p>Kan se ujevn ut. Er vanligvis mest et estetisk problem.<img src={img1b}/></p>
		},{
			text: 'C. På land – bunnplugg/lenseplugg (hvis det finnes)',
			legendIcon: 'y',
			modalContent: <p>Kontroller at den sitter godt fast før sjøsetting. Bunnpluggen kan være slitt eller sprukket. Noen har en pakning som bør sjekkes årlig. Byttes ved behov.<img src={img1c}/></p>
		},{
			text: 'D. På land – Kontroller at skroggjennomføringer er tette',
			legendIcon: 'y',
			modalContent: <p>Skroggjennomføringer med tilkoblinger for ventiler (kraner) og slanger, navigasjonsinstrumenter med kabeltilkoblinger samt selvlens.
				<br/>
				<b>Utvendig, på land: </b>
				Skrap bort bunnstoff og begroing og kontroller at det ikke er tegn til korrosjon, sprekker, rust eller spalter mellom flensen på skroggjennomføringen og skroget. Hvis en kuleventil har vært stengt gjennom vinteren, kan det være fare for at den har frosset i stykker og sprukket. Ved lynnedslag kan plastgjennomføringer til navigasjonsinstrumenter være skadet.
				<br/>
				<br/>
				<b>Innvendig, på land: </b>
				Kontroller at skroggjennomføringen sitter godt fast, ikke har angrep av korrosjon eller viser tegn til lekkasje. Sjekk at slangene ikke har sprekker eller er slitt, og at håndtaket (vredet) sitter fast og ikke er rustent.
				Tynne spiralforskyvede plastslanger er uegnet for skroggjennomføringer. I henhold til gjeldende regelverk skal slanger under eller nær vannlinjen være festet til skroggjennomføringen med doble slangeklemmer i rustfritt stål, montert med spennene vendt i motsatt retning. Ventilen bør beveges jevnlig for å unngå at den setter seg fast, og den skal være lett å åpne og lukke.
			</p>
		},{
			text: 'E. På land – selvlensende cockpit (hvis det finnes)',
			legendIcon: 'y',
			modalContent: <p>Fungerer avrenningen som den skal? Sitter eventuelle slanger godt fast? På båter der selvlensen munner ut under vannlinjen, skal det alltid være en avstengningsventil. Er den lett å åpne, og er den tett når den er stengt?<img src={img1e}/></p>
		},{
			text: 'F. På land – lensepumpe(r)',
			legendIcon: 'y',
			modalContent: <p>Kontroller at slangene er hele og i god stand, at det ikke er sprekker i gummimembranet på den manuelle lensepumpen, at sugeslangen har en sil der den suger i kjølsvinet, og at silen ikke er tett. Sjekk at håndtaket til den manuelle lensepumpen er lett tilgjengelig og passer godt i pumpens feste. Kontroller også at eventuell elektrisk lensepumpe fungerer som den skal.<img src={img1f}/></p>
		},{
			text: 'G. I sjøen – kontroller at skroggjennomføringer er tette',
			legendIcon: 'y',
			modalContent: <p>Skroggjennomføringer med tilkoblinger for ventiler (kraner) og slanger, navigasjonsinstrumenter med kabeltilkoblinger samt selvlens.
				Når båten ligger i sjøen, kontroller at det ikke er tegn til lekkasje ved skroggjennomføringen, og at det er helt tørt ved flensmutteren, ventilens gjenger og slangetilkoblinger. Ventilen bør beveges jevnlig for å unngå at den setter seg fast, og den skal være lett å åpne og lukke.<img src={img1g}/></p>
		},{
			text: 'H. I sjøen – kjølboltene',
			legendIcon: 'y',
			modalContent: <p>Kontroller at det ikke er lekkasje ved kjølboltene.<img src={img1h}/></p>
		},{
			text: 'I. I sjøen – løft alle dørker',
			legendIcon: 'y',
			modalContent: <p>Kontroller at det ikke finnes vann under dørkene eller i kjølsvinet. Sørg for at det er rent og tørt i kjølsvin og motorrom, slik at eventuelle lekkasjer oppdages raskt.</p>
		},{
			text: 'J. I sjøen – selvlensende cockpit (hvis det finnes)',
			legendIcon: 'y',
			modalContent: <p>Fungerer avrenningen som den skal? Sitter eventuelle slanger godt fast? På båter der selvlensen munner ut under vannlinjen, skal det alltid være en avstengningsventil. Er den lett å åpne, og er den tett når den er stengt?<img src={img1j}/></p>
		},

		{ header: '2. Sikkerhetsutstyr' },
		{
			text: 'A. Anker',
			legendIcon: 'y',
			modalContent: <p>Det finnes en rekke forskjellige typer ankere i ulike størrelser og for forskjellige bunnforhold. Tilpass ankeret etter båtens størrelse og ankringsdybde, inkludert en margin for uplanlagt nødankring. Kontroller tilstanden på lina/kjettingen og at sjaklene er godt strammet og sikret. Hvis du har ankerspill av noe slag, vær vant til å ha enden på tampen festet til båten.<img src={img2a}/></p>
		},{
			text: 'B. Reserveanker og drivanker',
			legendIcon: 'y',
			modalContent: <p>Det anbefales at du har et reserveanker og et drivanker ombord, og at de er lett tilgjengelige.<img src={img2b}/></p>
		},{
			text: 'C. Badestige/redningsstige',
			legendIcon: 'y',
			modalContent: <p>Stigen bør være minst 560 mm under vannlinjen. Kontroller at du faktisk klarer å klatre opp og at du kan felle den ned når du ligger i vannet.<img src={img2c}/></p>
		},{
			text: 'D. Linjer for tauing og lignende',
			legendIcon: 'y',
			modalContent: <p>Tilpasses etter båtens størrelse. Kontroller at linene er lett tilgjengelige og ikke er sammenfiltret.<img src={img2d}/></p>
		},{
			text: 'E. Røykvarsler',
			legendIcon: 'y',
			modalContent: <p>Kontroller og test røykvarsleren og batteriene i henhold til leverandørens instruksjoner.<img src={img2e}/></p>
		},{
			text: 'F. Brannteppe/brannslukker',
			legendIcon: 'y',
			modalContent: <p>Kontroller at brannteppet finnes i etuiet, at det er helt, og at du vet hvor det finnes når du trenger det. Kontroller at manometeret står på grønt, at slangen er hel, at forseglingen er intakt, samt at datoen for siste kontroll eller utløpsdato er synlig. Vri på slukkeren noen ganger og bank lett på siden og "lytt" for å sikre at pulveret beveger seg fritt i slukkeren. Har båten litiumbatterier ombord, kreves spesielle brannslukkere. Kontroller kravene fra ditt forsikringsselskap.<img src={img2f}/></p>
		},{
			text: 'G. Brannslukker motorrom',
			legendIcon: 'y',
			modalContent: <p>Brann i motorrommet skal kunne slukkes uten at lukene åpnes. Dette kan ordnes gjennom et sprinklersystem eller et annet fastslukkingssystem i motorrommet, eller ved et hull i motorlokket/motorhetten der håndbrannslukkerens slange kan føres inn.<img src={img2g}/></p>
		},{
			text: 'H. Båtshake/bøyeholder',
			legendIcon: 'y',
			modalContent: <p>Kontroller at kroken og lignende sitter godt fast, spesielt viktig for båtshaker i teleskoputførelse.<img src={img2h}/></p>
		},{
			text: 'I. CE-merking/blått skilt',
			legendIcon: 'y',
			modalContent: <p>Angir blant annet maksimalt antall personer ombord, maksimal last og maksimal motorstyrke.<img src={img2i}/></p>
		},{
			text: 'J. Fendere',
			legendIcon: 'y',
			modalContent: <p>Minst 4 fendere anbefales (tilpasset båtens størrelse).<img src={img2j}/></p>
		},{
			text: 'K. Flytevester eller flyteplagg',
			legendIcon: 'y',
			modalContent: <p>Skal alltid være ombord og brukes av alle personer ombord. Flytevester skal være CE-merket. Bruk grenbånd dersom det finnes. Vedlikehold oppblåsbare modeller i henhold til produsentens anbefalinger.<img src={img2k}/></p>
		},{
			text: 'L. Førtøyningsliner',
			legendIcon: 'y',
			modalContent: <p>Minst 4 liner anbefales (tilpasset båtens vekt). Fortøyningsfjær/støtdempere bør være til stede, kontroller tilstanden på disse og bytt ved behov.<img src={img2l}/></p>
		},{
			text: 'M. Bøtter',
			legendIcon: 'y',
			modalContent: <p>Med line/tau, anbefales. De er nyttige for å øse vann, slukke brann eller for andre nødvendige situasjoner som kan oppstå.</p>
		},{
			text: 'N. Kasteline/redningsline',
			legendIcon: 'y',
			modalContent: <p>Kontroller at den er hel og ser i god stand ut. OBS: En flytende line, som den skal være, brytes lett ned av sollys. Kun den solbeskyttede delen skal stikke ut av kastposen. Tren på å bruke linjen av og til.<img src={img2n}/></p>
		},{
			text: 'O. Kryssholt',
			legendIcon: 'y',
			modalContent: <p>Kontrollere at de sitter fast<img src={img2o}/></p>
		},{
			text: 'P. Lanterner',
			legendIcon: 'y',
			modalContent: <p>Kontroller at de fungerer og er riktig montert. Lanternene skal ikke blende rormannen, så de bør testes i mørket. Ekstra lyspære/LED-lampe anbefales.<img src={img2p}/></p>
		},{
			text: 'Q. Motorromsventilator (hvis båt med bensindrevet innenbordsmotor)',
			legendIcon: 'y',
			modalContent: <p>Viktig for å ventilere bort bensindamp og redusere eksplosjonsfare. Kontroller at den fungerer. Den skal kjøres i minst 2 minutter før start og alltid ved tanking.</p>
		},{
			text: 'R. Rekke, pulpit',
			legendIcon: 'y',
			modalContent: <p>Kontroller festene i dekket, at tauene er hele og uskadde, samt at mantåget som er åpnbart, kan åpnes. Husk også å vurdere nett/rekkverk med tanke på småbarn og kjæledyr.<img src={img2r}/></p>
		},{
			text: 'S. Reservetank',
			legendIcon: 'y',
			modalContent: <p>Kontroller at den er plassert på en passende måte, forsvarlig festet, fylt med riktig drivstoff og ikke er for gammel. Sjekk også at plastdunken ikke har overskredet "siste bruksår".<img src={img2s}/></p>
		},{
			text: 'T. Signalhorn/tut',
			legendIcon: 'y',
			modalContent: <p>Kontroller at det fungerer. Det finnes også håndholdte versjoner.<img src={img2t}/></p>
		},{
			text: 'U. Sjøkart',
			legendIcon: 'y',
			modalContent: <p>Kontroller at det er oppdatert og gjelder for den planlagte ruten.<img src={img2u}/></p>
		},{
			text: 'V. Sikker ombord- og ilandstigning – seilbåt',
			legendIcon: 'y',
			modalContent: <p>Det er viktig med god sklibeskyttelse og håndtak. Pulpit og baugstige er også nyttige. Gode sko reduserer risikoen for å skli.<img src={img2v}/></p>
		},{
			text: 'W. Sikkerhetssele',
			legendIcon: 'y',
			modalContent: <p>Bør være tilgjengelig ved alene-seiling og ved seiling på åpent hav. Livlinen kan for eksempel festes i bånd langs dekket. Det er ofte en god idé med doble linjer – en kort og en lang festet til sikkerhetsselen.<img src={img2w}/></p>
		},

		{ header: '3. Nødutstyr' },
		{
			text: 'A. Førstehjelpsutstyr/first aid kit',
			legendIcon: 'y',
			modalContent: <p>Oppbevares i en vanntett pose. Kontroller innholdet og siste forbruksdato.<img src={img3a}/></p>
		},{
			text: 'B. Håndlyskaster/lyskaster',
			legendIcon: 'y',
			modalContent: <p>Kontroller at de fungerer.<img src={img3b}/></p>
		},{
			text: 'C. Kniv/lina/mykt materiale (for tetting)/plugg i mykt tre',
			legendIcon: 'y',
			modalContent: <p>For reparasjoner osv. Liggeunderlagsmateriale er nyttig for å lage plugger. Det er lett å rive av passende størrelser uten å bruke verktøy. Treplugger i riktig dimensjon kan festes med snor nær alle gjennomføringer, så de alltid er tilgjengelige ved nødsituasjoner. Lette tilgjengelige kniver på strategiske steder som pulpit/pushpit.<img src={img3c}/></p>
		},{
			text: 'D. Livbøye',
			legendIcon: 'y',
			modalContent: <p>Med kasteline og lys. Kontroller for nedbrytning på grunn av sollys.<img src={img3d}/></p>
		},{
			text: 'E. Mobiltelefon',
			legendIcon: 'y',
			modalContent: <p>Vannbeskyttet og helst med GPS. Last ned SOS Alarm 112-appen og legg inn viktige telefonnummer. Det er viktig å sjekke mobiloperatørens dekning.<img src={img3e}/></p>
		},{
			text: 'F. Nødraketter/håndbluss',
			legendIcon: 'y',
			modalContent: <p>Ved seiling i områder med dårlig mobildekning og åpent vann. Det finnes også LED-nødraketter/håndbluss i dag. Kontroller siste forbruksdato. Utløpte produkter skal returneres til forhandleren.<img src={img3f}/></p>
		},{
			text: 'G. Nødsender',
			legendIcon: 'y',
			modalContent: <p>PLB (Personal Locator Beacon), SPOT (Satellite Personal Tracker), EPIRB (Emergency Position Indicating Radio Beacon). Bra å ha på åpent vann og i områder med dårlig mobildekning. OBS: Disse må være korrekt registrert for å fungere.<img src={img3g}/></p>
		},{
			text: 'H. Verktøy for å frigjøre en avbrutt mast/brudd',
			legendIcon: 'y',
			modalContent: <p>Ved riggfeil kan kabler eller vantskruer måtte kuttes, og masten slippes over bord. Baufil, boltsaks og vajertang kan være passende verktøy. Kontroller med riggprodusenten for spesifikke anbefalinger.<img src={img3h}/></p>
		},{
			text: 'I. VHF',
			legendIcon: 'y',
			modalContent: <p>Bra å ha på seilaser i åpent vann. En bærbar, vanntett VHF kan være et nyttig supplement eller en reserveantenne til en fast installert VHF ved eventuelt mastbrudd. Før hver sesong bør funksjon kontrolleres gjennom prøvesending, og håndteringen bør repeteres.<img src={img3i}/></p>
		},{
			text: 'J. Livflåte',
			legendIcon: 'y',
			modalContent: <p>Kontrolleres, pakkes og festes i henhold til produsentens instruksjoner.<img src={img3j}/></p>
		},{
			text: 'K. Merking av fartøy',
			legendIcon: 'y',
			modalContent: <p>Det anbefales å merke fartøyene sine, som båt, slepejolle og livflåte. Dette gjør det mulig å kontakte eieren for å kontrollere at ingenting har skjedd dersom fartøyet blir funnet drivende uten person ombord.</p>
		},

		{ header: '4. Fremdrift' },
		{
			text: 'A. Avgasslange/lyddemper for seilbåt med innenbordsmotor',
			legendIcon: 'y',
			modalContent: <p>Kontroller at ikke vann kan trenge inn aktenfra under seiling. Eksosrøret skal gå i en bøyning opp mot dekket. Den laveste delen av avgasslangen/lyddemperen skal romme det vannet som kan være i systemet når motoren er slått av.</p>
		},{
			text: 'B. Akseltetning',
			legendIcon: 'y',
			modalContent: <p>Ved innenbordsmotor med strak aksel. Finnes i forskjellige utførelser og merker. Kontroller tettheten og servicer i henhold til produsentens anbefalinger.<img src={img4b}/></p>
		},{
			text: 'C. Verktøy samt brytepinne og tennplugger i reserve',
			legendIcon: 'y',
			modalContent: <p>Brytepinne er vanligvis kun nødvendig for mindre utenbordsmotorer. Sørg for å ha riktig verktøy og reservere brytepinner og tennplugger tilgjengelig.</p>
		},{
			text: 'D. Belg og dekselplate for motor med S-drev',
			legendIcon: 'y',
			modalContent: <p>Kontroller for sprekkdannelse. Bytt i henhold til produsentens anbefalinger.<img src={img4d}/></p>
		},{
			text: 'E. Impeller',
			legendIcon: 'y',
			modalContent: <p>Kontroller før hver sesong og bytt ved behov i henhold til motorprodusentens anbefalinger. Ha en i reserve ved lengre turer, for eksempel på åpent vann. Øv på å bytte før du trenger å gjøre det (for innenbordsmotor). Oppbevar reserveimpelleren mørkt i en tett plastpose slik at gummiet ikke tørker ut så raskt.<img src={img4e}/></p>
		},{
			text: 'F. Kjølevann',
			legendIcon: 'y',
			modalContent: <p>Når motoren startes, kontroller alltid at kjølevannet kommer som det skal.</p>
		},{
			text: 'G. Kjølevannsslange',
			legendIcon: 'y',
			modalContent: <p>Med en lavt plassert motor må kjølevannet komme inn via en slange i en bøyning godt over vannlinjen, med vakuumventil på høyeste punkt. Kontroller for eventuelle sprekkdannelser i kjølevannsslanger.</p>
		},{
			text: 'H. Motor',
			legendIcon: 'y',
			modalContent: <p>Serve motoren i henhold til instruksjonene fra motorleverandøren.<img src={img4h}/></p>
		},{
			text: 'I. Motorfeste – ved utenbordsmotor',
			legendIcon: 'y',
			modalContent: <p>Kontroller motorfestet på akterspeilet.</p>
		},{
			text: 'J. Offeranoder',
			legendIcon: 'y',
			modalContent: <p>Kontroller før hver sesong og bytt ved behov. De kan finnes på både motor og aksel, samt på ror og skrog i metall. De kan også finnes i innenbordsmotorens kjølesystem.<img src={img4j}/></p>
		},{
			text: 'K. Olje',
			legendIcon: 'y',
			modalContent: <p>I motor, gir og drev der det er aktuelt. Kontrolleres regelmessig.</p>
		},{
			text: 'L. Propell, propellaksling',
			legendIcon: 'y',
			modalContent: <p>På land – Kontroller at det ikke er noe glipp, og at det ikke finnes sprekker ved festing av eventuelle støttestag. Kontroller at bolten som propellen er festet med er sikret, og at bladene på foldepropellen er ordentlig sikret.<img src={img4l}/></p>
		},{
			text: 'M. Sjøvannfilter (motorkjøling)',
			legendIcon: 'y',
			modalContent: <p>Kontroller og rengjør regelmessig, også i løpet av båtsesongen.<img src={img4m}/></p>
		},

		{ header: '5. Styresystem' },
		{
			text: 'A. På land – Roroppheng',
			legendIcon: 'y',
			modalContent: <p>Kontroller at det ikke er noe bekymringsfullt glipp i opphenget, og at alle deler er i god stand. Kontroller roret om høsten og våren, for eksempel for sprekker, frostsprengninger og rust.<img src={img5a}/></p>
		},{
			text: 'B. Rorkult',
			legendIcon: 'y',
			modalContent: <p>Det er lurt å ha en reserve-rorkult (alltid hvis båten har rattstyring). Teste nødstyringen på land eller i rolige farvann, slik at du vet hvordan den fungerer når den virkelig trengs.</p>
		},{
			text: 'C. Kompass montert på rattpidestall',
			legendIcon: 'y',
			modalContent: <p>Kontroller når båten ligger stille at kompasset ikke blir påvirket når rattet vries, eller av elektronisk utstyr.<img src={img5c}/></p>
		},{
			text: 'D. Reservestyring',
			legendIcon: 'y',
			modalContent: <p>Ved havseiling er det ønskelig med utprøvd nødstyring hvis hele roret skulle forsvinne. Test nødstyringen på land eller i rolige farvann, slik at du vet hvordan den fungerer når den virkelig trengs.</p>
		},{
			text: 'E. Styring med vajrer',
			legendIcon: 'y',
			modalContent: <p>Kontroller at vajrene er i god stand og at de ikke går i for skarpe bøyninger.</p>
		},{
			text: 'F. Hydraulisk styringssystem',
			legendIcon: 'y',
			modalContent: <p>Kontroller funksjonen og oljenivået.</p>
		},

		{ header: '6. Elektrisk anlegg' },
		{
			text: 'A. Avansert anlegg bør kontrolleres av fagperson.',
			legendIcon: 'y',
		},{
			text: 'B. Batterier',
			legendIcon: 'y',
			modalContent: <p>Batteriene skal være plassert adskilt fra drivstofftankene og være godt festet, samt plassert slik at de ikke blir oversvømt av moderat mengde vann som trenger inn. Ingen løse gjenstander som kan kortslutte polene skal være i samme rom. Sjekk for eventuell oksidasjon på polene. Rengjør og smør inn. Det bør alltid være en lett tilgjengelig hovedstrømbryter slik at batteriene kan kobles fra i tilfelle elektrisk feil. Hvis båten har litiumbatterier, er det viktig å skaffe god kunnskap om den aktuelle typen og følge produsentens anbefalinger. Litium har mange fordeler, men krever forskjellig vedlikehold, lagring, lading samt håndtering ved skader eller brann sammenlignet med blybatterier. Spesialladere og et BMS (Battery Management System) er påkrevd, og generator/motoren må være tilpasset. Hvis batterisystemet byttes fra blybatterier til litium, skal arbeidet utføres på en fagmessig måte med relevante forskrifter og standarder. Feil håndtering eller installasjon kan skade batteriene. Ladere for litiumbatterier skal benyttes.<img src={img6b}/></p>
		},{
			text: 'C. Elkabler',
			legendIcon: 'y',
			modalContent: <p>Kabler skal være i flertrådet utførelse og dimensjonert i henhold til gjeldende regler for elektrisk installasjon i båt.<img src={img6c}/></p>
		},{
			text: 'D. Sikringer i reserve',
			legendIcon: 'y',
			modalContent: <p>Ha alltid reservesikringer tilgjengelig ombord, tilpasset båtens elektriske system og de ulike kretsene.</p>
		},

		{ header: '7. Drivstoff-system' },
		{
			text: 'A. Drivstoffilter',
			legendIcon: 'y',
			modalContent: <p>Bytt drivstoffilter før hver sesong. Ved oppdagelse av belegg, rengjør drivstofftanken. Det er lurt å ha et ekstra drivstoffilter i reserve, også i tilfeller der båten er utstyrt med omkoblingsbart dobbelt drivstoffilter.<img src={img7a}/></p>
		},{
			text: 'B. Drivstoffslanger',
			legendIcon: 'y',
			modalContent: <p>Kontroller at de er av godkjent kvalitet og i god stand, trukket med gummigjennomføringer for å unngå slitasjeskader.</p>
		},{
			text: 'C. Drivstofftank',
			legendIcon: 'y',
			modalContent: <p>Kontroller tanktilkoblinger, pakninger og bytt ved behov før hver sesong. Rengjør tanken ved behov.<img src={img7c}/></p>
		},{
			text: 'D. Vannseparator (hvis det finnes)',
			legendIcon: 'y',
			modalContent: <p>Kontroller at det ikke er lekkasje ved filteret og dets tilkoblinger, og at de er byttet i henhold til instruksjonene. Tapp ut eventuell vann.<img src={img7d}/></p>
		},

		{ header: '8. Gassanlegg' },
		{
			text: 'A. Gassbeholdere',
			legendIcon: 'y',
			modalContent: <p>Skal plasseres stående i et ventilert og drenert rom.</p>
		},{
			text: 'B. Gassregulator',
			legendIcon: 'y',
			modalContent: <p>Kontroller og bytt i henhold til produsentens anbefalinger. Skal være CE-merket for maritimt bruk.<img src={img8b}/></p>
		},{
			text: 'C. Gasslanger',
			legendIcon: 'y',
			modalContent: <p>Kontroller at de er av godkjent kvalitet og i god stand, og at de er trukket gjennom gummigjennomføringer for å unngå slitasjeskader. Bytt slangene i henhold til produsentens anbefalinger. Gassanlegget har ofte pakninger som bør byttes eller kontrolleres for sprekker.<img src={img8c}/></p>
		},{
			text: 'D. Gassvarsler',
			legendIcon: 'y',
			modalContent: <p>Dersom det finnes gass og/eller varmer om bord, bør den varsle for propan (gass) og/eller karbonmonoksid.<img src={img8d}/></p>
		},{
			text: 'E. Lekkasjeindikator',
			legendIcon: 'y',
			modalContent: <p>Finnes i ulike utførelser. Kontroller funksjonen i henhold til produsentens instruksjoner.<img src={img8e}/></p>
		},

		{ header: '9. Toalett' },
		{
			text: 'A. Stengeventiler for toalett og tank',
			legendIcon: 'y',
			modalContent: <p>Kontroller at de er tette og ikke sitter fast.<img src={img9a}/></p>
		},{
			text: 'B. Skroggjennomføringer for WC',
			legendIcon: 'y',
			modalContent: <p>Skroggjennomføringer med tilkoblinger for ventiler (kraner) og slanger. Når båten ligger på vannet – kontroller at det ikke finnes tegn til lekkasje ved skroggjennomføringen, og at det er helt tørt ved gjennomføringens flensmutter, ventilens gjenger og slangetilkoblinger. Ventilen bør beveges jevnlig for å ikke sette seg fast, og den skal være lett å åpne og stenge.<img src={img9b}/></p>
		},{
			text: 'C. Hvis det finnes vakuumventil i systemet',
			legendIcon: 'y',
			modalContent: <p>Kontroller at den fungerer.</p>
		},

		{ header: '10. Rigg og seil' },
		{
			text: 'A. Er riggen festet på riktig måte',
			legendIcon: 'y',
			modalContent: <p>Det finnes mye informasjon på nettet, for eksempel "RÅD OG TIPS - Seldén".</p>
		},{
			text: 'B. Fall',
			legendIcon: 'y',
			modalContent: <p>Kontroller for slitasje og nedbrytning forårsaket av sollys.</p>
		},{
			text: 'C. Mastefot, gjennomgang av dekk',
			legendIcon: 'y',
			modalContent: <p>Kontroller at mastefoten er feilfri. Hvis masten går gjennom dekket, kontroller gjennomføringen og at gummikiler hindrer masten fra å bevege seg i hullet. Eventuelle elektriske tilkoblinger bør også kontrolleres.<img src={img10c}/></p>
		},{
			text: 'D. Mast',
			legendIcon: 'y',
			modalContent: <p>Kontroller at det ikke er noen bulker eller skader.<img src={img10d}/></p>
		},{
			text: 'E. Rev-arrangement',
			legendIcon: 'y',
			modalContent: <p>Prøv årlig å reve for øvelsens skyld og for å se at arrangementene fungerer.</p>
		},{
			text: 'F. Forstagsprofil og rullesystem',
			legendIcon: 'y',
			modalContent: <p>Rullesystemet kontrolleres slik at profilen kan dreie seg lett. Profilen kontrolleres for å sikre at den ikke er vridd eller bøyd, og at seilet lett kan heises helt til toppen. En viktig detalj i rullefokksystemet er at man har riktig fallvinkel (min. 10°), det vil si at fallet ledes bort fra forstaget. Dette er for å hindre falltrassel som kan få ødeleggende konsekvenser. Forstag kan bli vridd på grunn av falltrassel, men det kan også føre til at topprofilen blir ødelagt og et system som ikke kan håndteres.<img src={img10f}/></p>
		},{
			text: 'G. Rullestor',
			legendIcon: 'y',
			modalContent: <p>Kontroller at den går lett. Serve den i henhold til produsentens anbefalinger. Bilde: Seldén Mast AB.<img src={img10g}/></p>
		},{
			text: 'H. Sjakkel',
			legendIcon: 'y',
			modalContent: <p>Uskadet og sikkert låst.<img src={img10h}/></p>
		},{
			text: 'I. Seil',
			legendIcon: 'y',
			modalContent: <p>Sjekk for slitasje og eventuell nedbrytning forårsaket av UV-lys.<img src={img10i}/></p>
		},{
			text: 'J. Vant og stag',
			legendIcon: 'y',
			modalContent: <p>En vanlig wire består av 19 tråder. Når en tråd (kardel) har bristet, bytter man ut den wiren, og helst "hele paret". Det vil si, en bristet kardel på styrbord undervant gjør at man bytter også babord undervant, ettersom de normalt har vært utsatt for like mange lastvekslinger. Ofte går en kardel av helt ved munningen av et presset ende stykke, og noen ganger separerer den og vises tydelig som en spiral langs wiren. Men noen ganger må man bruke en liten skrutrekker på de ytre kardelene for å oppdage bruddet. Vantskruene skal være sikret. Kontroller saxsprintene og ha med reserve.<img src={img10j}/></p>
		},{
			text: 'K. Vinsjer og vinsjhåndtak',
			legendIcon: 'y',
			modalContent: <p>Kontroller at de ikke er løse eller går tungt. Serve i henhold til produsentens anbefalinger. Vinsjhåndtak i reserve bør være tilgjengelig.<img src={img10k}/></p>
		},
	]
}

export default seilbatBeregnetForOvernatting
